import { Provider } from "react-redux";
import { store } from "./services/stores";
import AppNav from "./navigation/AppNav";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "sweetalert2/dist/sweetalert2.min.css";

const queryClient = new QueryClient();

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <Provider store={store}>
        <AppNav></AppNav>
      </Provider>
    </QueryClientProvider>
  );
}

export default App;
